import React, { createContext, useContext, ReactNode, useState } from 'react'

interface ChatContextType {
  changePage: (
    page: string,
    chat?: string | number | null,
    typeAction?: string,
    params?: Record<string, unknown>,
  ) => void
  unreadSupportMessagesCount: number
  setUnreadSupportMessagesCount: (count: number) => void
  currentOpenChatId: string | number | null
  setCurrentOpenChatId: (chatId: string | number | null) => void
  lastMessageUpdate: ChatLastMessageUpdate | ChatLastMessageUpdate[] | null
  setLastMessageUpdate: (message: ChatLastMessageUpdate | ChatLastMessageUpdate[]) => void
}

interface ChatLastMessageUpdate {
  chatId: string | number
  id?: string | number
  message: unknown
  createdAt: string
  authorAvatar?: string | null
}

const ChatContext = createContext<ChatContextType | null>(null)

export const useChatContext = () => {
  const context = useContext(ChatContext)
  return context
}

interface ChatProviderProps {
  children: ReactNode
  changePage: (
    page: string,
    chat?: string | number | null,
    typeAction?: string,
    params?: Record<string, unknown>,
  ) => void
}

export const ChatProvider: React.FC<ChatProviderProps> = ({
  children,
  changePage,
}) => {
  const [unreadSupportMessagesCount, setUnreadSupportMessagesCount] = useState<number>(0)
  const [currentOpenChatId, setCurrentOpenChatId] = useState<string | number | null>(null)
  const [lastMessageUpdate, setLastMessageUpdate] = useState<ChatLastMessageUpdate | ChatLastMessageUpdate[] | null>(null)

  return (
    <ChatContext.Provider value={{ 
      changePage, 
      unreadSupportMessagesCount, 
      setUnreadSupportMessagesCount,
      currentOpenChatId,
      setCurrentOpenChatId,
      lastMessageUpdate,
      setLastMessageUpdate,
    }}>
      {children}
    </ChatContext.Provider>
  )
}
